import { Card } from "react-bootstrap";
import TimerComponent from "../Timer";
import log from "loglevel";
import moment from "moment";

const QuizTimeLeft = ({ labAvailableTime, labExpired, millisecondsLeft, setAutoSub, setIsLabExpired, handleTimeUp }) => {

    const handleAutoSubmit = () => {
        log.log("Auto-submitting...");
        setAutoSub(true);
        if (labAvailableTime) {
            let till = moment(labAvailableTime);
            let now = moment();
            log.log({ labAvailableTime: now.isAfter(till) })
            if (now.isAfter(till)) {
                setIsLabExpired(true);
            } else {
                setIsLabExpired(true);
            }
        }
        const submitButton = document.getElementById("submitButton");
        if (submitButton) {
            // Trigger click event with custom data attribute to indicate auto-submit
            // handleTimeUp() is called by handleConfirmSubmission after the POST completes,
            // so the student sees submission confirmation before being blocked.
            submitButton.setAttribute('data-auto-submit', 'true');
            submitButton.click();
        } else {
            // No submit button (already submitted or disabled) — still block since time is up
            log.error("Submit button not found");
            if (handleTimeUp) {
                handleTimeUp();
            }
        }
        // Trigger exam-level blocking after auto-submit
        if (handleTimeUp) {
            handleTimeUp();
        }
    }

    return (
        <>
            {(labAvailableTime || millisecondsLeft > 0) && !labExpired && <div style={{ marginBottom: "30px" }}>
                <Card style={{ marginRight: "10px", borderRadius: "20px", backgroundColor: "#F5FFFA" }}>
                    <Card.Footer className="text-muted" style={{ padding: "35px" }}>
                        <TimerComponent key={`timer-${millisecondsLeft}`} labAvailableTill={labAvailableTime} onTimeUp={handleAutoSubmit} millisecondsLeft={millisecondsLeft} />
                    </Card.Footer>
                </Card>
            </div>}
        </>
    )
}

export default QuizTimeLeft;